import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ActionSearch from 'material-ui/svg-icons/action/search';
import {white} from 'material-ui/styles/colors';

export class DocSearch extends Component {

   componentDidMount() {
      const {docSearch} = this.props;
      if (docSearch && docSearch.apiKey !== ""){
         const embedCode = '<script>docsearch({\n' +
            'apiKey: "' + docSearch.apiKey + '",\n' +
            'indexName: "' + docSearch.indexName + '",\n' +
            'inputSelector: "#docsearch-input",\n' +
            'debug: false // Set debug to true if you want to inspect the dropdown\n' +
            '});\n' +
            '</script>';
         var $docSearchContainer = window.jQuery('#docsearch-container');
         if ($docSearchContainer && $docSearchContainer.length && !$docSearchContainer.hasClass('ReadyToUse')){
            $docSearchContainer.addClass('ReadyToUse').append(embedCode);
         }
      }
   }

   render() {
      const {isAuthenticated} = this.props;
      const DocSearchIconContainerStyle = {
         width: 72,
         height: '100%',
         display: 'flex',
         position: 'absolute',
         alignItems: 'center',
         pointerEvents: 'none',
         justifyContent: 'center'
      };
      const DocSearchSpan = {
         position: 'relative',
         display: 'inline-block',
         direction: 'ltr'
      };

      return (
         <div style={{marginTop: 4, marginRight: 8}}>
            {isAuthenticated ?
               <div id="docsearch-container" className="DocsearchContainer">
                  <div style={DocSearchIconContainerStyle}>
                     <ActionSearch color={white}/>
                  </div>
                  <span className="algolia-autocomplete" style={DocSearchSpan}>
                     <input id="docsearch-input"/>
                  </span>
               </div> : ""
            }
         </div>
      );
   }
}

DocSearch.propTypes = {
   isAuthenticated: PropTypes.bool,
   docSearch: PropTypes.object
};

function mapStateToProps(state) {
   return {
      isAuthenticated: state.auth.isAuthenticated,
      docSearch: state.conf.docSearch
   }
};

export default connect(mapStateToProps)(DocSearch);



// WEBPACK FOOTER //
// ./src/components/DocSearch.js